export const contactsData = {
    email: 'mrishafayet003@gmail.com',
    phone: '+8801836-539470',
    address: 'Uttara, Dhaka, Bangladesh. ',

    sheetAPI: ''
}